import { ResetPasswordPage } from '@ubus/shared';

function ResetPassword() {
  return (
    <ResetPasswordPage
      successRedirect="/login"
      portalLabel="Set a new admin password"
    />
  );
}

export default ResetPassword;
